module.exports = __webpack_public_path__ + "static/media/esxates_gr.1b01e853.png";